export default __webpack_public_path__ + "static/media/logo-vc-2.78c1ca3b.png";